import { render, staticRenderFns } from "./UserPicInfo.vue?vue&type=template&id=31aef0bb&"
import script from "./UserPicInfo.vue?vue&type=script&lang=js&"
export * from "./UserPicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports